interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '女神漫画上的漫画都是免费的吗？',
    answer: '是的，女神漫画网上的所有漫画内容均为免费阅读。我们致力于为广大漫画爱好者提供零门槛的阅读体验，无需付费订阅，打开网页即可畅享海量韩漫、日漫、国漫资源。',
  },
  {
    question: '什么是下拉式在线阅读？需要下载App吗？',
    answer: '下拉式阅读是一种流畅的网页阅读模式，您只需在浏览器中滚动页面即可连续阅读漫画内容，无需翻页点击。无需下载任何App或插件，支持手机、平板和电脑多端访问。',
  },
  {
    question: '漫画多久更新一次？能第一时间看到最新话吗？',
    answer: '站内漫画每日同步更新，热门连载作品会第一时间追踪最新话发布。您可以通过"最新更新"模块查看当日更新的漫画列表，热门排行榜也会实时反映作品热度变化。',
  },
  {
    question: '支持哪些类型的漫画？有分类筛选功能吗？',
    answer: '女神漫画覆盖恋爱、奇幻、悬疑、热血、校园、科幻、古风等多种题材。您可以通过首页的"漫画索引"按分类浏览，也可以使用热门话题标签快速定位感兴趣的漫画类型。',
  },
  {
    question: '阅读过程中遇到问题怎么反馈？',
    answer: '如遇到加载缓慢、图片显示异常等问题，可以通过页面底部的"联系我们"区域获取反馈渠道，我们的运营团队会尽快处理。同时建议保持浏览器为最新版本以获得最佳阅读体验。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
          常见问题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
          关于女神漫画的常见疑问解答
        </p>
        <div className="max-w-3xl mx-auto divide-y divide-background-200">
          {faqs.map((faq, idx) => (
            <div key={idx} className="py-5 md:py-6">
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}